module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "d7e60510"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Auth_ISBN9781402790959_epub_toc_r1#d7e2826",
      "id": "d14e330"
    }
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OREWORD ")])])]), _vm._v(" "), _c('p', {
    staticClass: "txc",
    staticStyle: {
      "margin-top": "-5.8em"
    },
    attrs: {
      "id": "d14e334"
    }
  }, [_c('i', [_vm._v("by Elie Wiesel")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e61510"
    }
  }, [_vm._v("A cry of despair? An act of faith? A heartrending echo of the Akedah, the eternal blight to which our people seem to have been subjected since the time of Abraham and his son?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e62610"
    }
  }, [_vm._v("This story, told by a child who became the chief rabbi of Israel, is all that—and much more.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e63510"
    }
  }, [_vm._v("Our paths crossed more than once. We were in Buchenwald together. We lived through its liberation together. We came to France together, with a group of four hundred young boys, led with unstinting devotion by the magnificent Oeuvre de Secours aux Enfants (Society for Rescuing Children). Lulek was the youngest—I would say the smallest among us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e65810"
    }
  }, [_vm._v("But it was he who recalled our first true encounter.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e66310"
    }
  }, [_vm._v("We had come—he from Tel Aviv and I from New York—to participate in the annual ceremony of the March of the Living for the Yom HaShoah (Holocaust Remembrance Day) at Birkenau. In introducing me to a gathering of more than ten thousand people, he recalled that particular event. In May 1945 he had just learned—from his brother Naphtali—of the death of their mother. And it was you, said Lulek, the future chief rabbi of Israel, who taught me to recite the Kaddish.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e69511"
    }
  }, [_vm._v("I had forgotten it; he had as well because he did not mention it in his autobiography.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e70311"
    }
  }, [_vm._v("But in this book, so rich in dramatic memories that often extend beyond the personal, he sees himself as a child. In the ghetto of Piotrków Trybunalski. Cruel scenes in the synagogue. The selections later on. The overwhelming dread of successive separations. The scenes, each bloodier and more bruising, one after the other, all blending together.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e72111"
    }
  }, [_vm._v("He sees his father again, the chief rabbi of the city, humiliated and beaten by the SS because he refused to cut his beard. He remembers him telling the Jews to defend themselves by “tooth and nail.” He recounts his father’s final words about the martyrdom of Rabbi Akiva: his "), _c('i', [_vm._v("Shema Yisrael")]), _vm._v(" resounded to the heavens.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e74311"
    }
  }, [_vm._v("He evokes life with his mother in their attic hideout. The constant anguish. The daily miracles. Naphtali’s escape from Auschwitz. Purim and Passover in the camp. The loss of their father’s manuscript, which the elder brother always carried with him: a study on the sanctification of the Divine Name. The appearance of Feodor, the Russian sergeant from Rostov who became his guardian angel.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e76511"
    }
  }, [_vm._v("Like most memoirs written by survivors, each story is full of silent tears, of invisible wounds, of unfathomable gazes, but also of that which menaces life, hope, dignity. In this accursed place, the enemy has absolute power.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e77611"
    }
  }, [_vm._v("We were separated, Lulek and I, in Écouis, France. After several weeks, the first group left for Palestine, including the two brothers. In the Holy Land, they discovered that they had family there.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e78811"
    }
  }, [_vm._v("It’s best if I stop now. Let the reader discover alone the intensity of this overwhelming journey that will describe how one can live with the dead or else join the dead. How one can cling, even in the deepest shadows, to the light of faith. And, above all, how one can build on ashes. And how a little boy from Piotrków and from Buchenwald succeeded in growing and blossoming under the radiance of the blue sky of the Jewish state. Did he know, could he know, what great joys awaited him there?")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e81311"
    }
  }, [_vm._v("Me, I remained in France. And many years flowed by before we reunited.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e82111"
    }
  }, [_vm._v("To understand his well-deserved achievements—attained under the heavy burden of a nameless and limitless past that stretches from Auschwitz to the Sinai—the reader also follows him from the depths of ultimate suffering to the summit of honors and victories. In the original Hebrew edition, the author sets his story in the shadow of the flames of Akedah.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e84712"
    }
  }, [_vm._v("Only this time, the father does not return from Mount Moriah."), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txr14",
    attrs: {
      "id": "d7e85512"
    }
  }, [_vm._v("—E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LIE ")]), _vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IESEL ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-df0676e0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Auth_ISBN9781402790959_epub_c8_r1.vue
// module id = 78
// module chunks = 0